<div class="row justify-content-center">
    <div class="col-6">
        <div class="card text-center mt-5">
            <div class="card-header primary">
                <H4 paflabel="Dossier_sauvegarde"></H4>
            </div>
            <div class="card-body">
                <H5 paflabel="Votre_dossier_a_ete_sauvegarde_en_l_etat"></H5>
                <H6 paflabel="Votre_dossier_ne_sera_pas_transmis_a_notre_service_Achats_tant_qu_il_ne_sera_pas_complet"></H6>
                <H6 paflabel="Vous_pourrez_le_finaliser_ulterieurement_en_vous_reconnectant_avec_les_identifiants_suivants"></H6>
                <BR/>
                <H6 class="d-flex justify-content-center" style="width:100%;">
                    <div class="mt-1"><paflabel lblCod="identifiant"></paflabel> &nbsp;:</div>
                    <span class="card ml-1 px-3 py-1 text-primary">{{loggedUserId}}</span>
                </H6>
                <BR/>
                <a *ngIf="supplierIdIfUnique==0" class="btn btn-primary" routerLink="/suppliers" paflabel="Tableau_de_bord"></a>
                 <a *ngIf="supplierIdIfUnique!=0" class="btn btn-primary" [routerLink]="'/supplier-details/'+supplierIdIfUnique" paflabel="Retour_a_la_fiche_fournisseur"></a>
               
            </div>
        </div>


    </div>
</div>